function StateOfHealthAnonymizedWrapperVO(allergies, geneticDisorders, chronicAndPastIllness, hospitalsAndSanatorium,
                                laboratoryTestResults, vaccinationsAndSerum, takenDrugs, medicalProcedures, chronicDiagnosis, nonChronicDiagnosis) {
    
    this.allergies = allergies;
    this.geneticDisorders = geneticDisorders;
    this.chronicAndPastIllness = chronicAndPastIllness;
    this.hospitalsAndSanatorium = hospitalsAndSanatorium;
    this.laboratoryTestResults = laboratoryTestResults;
    this.vaccinationsAndSerum = vaccinationsAndSerum;
    this.takenDrugs = takenDrugs;

    var _typeContext = {
        allergies: AllergyVO,
        geneticDisorders: GeneticDisorderVO,
        chronicAndPastIllness: ChronicAndPastIllnessVO,
        hospitalsAndSanatorium: HospitalAndSanatoriumVO,
        laboratoryTestResults: LaboratoryTestResultVO,
        vaccinationsAndSerum: VaccinationAndSerumVO,
        takenDrugs: TakenDrugVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}